export default __webpack_public_path__ + "img/0fedefc4d1c958f286fcf697bee1376d.png";